import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const PinIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 16">
      <g clipPath="url(#clip0_539_13253)">
        <path d="M5.71848 10.2786L0.796875 15.2002" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M3.08927 5.82053C2.94188 5.85004 2.80527 5.91899 2.694 6.02005C2.58273 6.1211 2.50097 6.25046 2.45745 6.39433C2.41393 6.5382 2.41027 6.69119 2.44687 6.83697C2.48347 6.98276 2.55895 7.11588 2.66527 7.22213L8.77727 13.3341C8.88352 13.4404 9.01664 13.5159 9.16242 13.5525C9.30821 13.5891 9.4612 13.5855 9.60507 13.542C9.74894 13.4984 9.8783 13.4167 9.97935 13.3054C10.0804 13.1941 10.1494 13.0575 10.1789 12.9101L11.1197 8.20133L14.8157 5.85093C14.9206 5.78413 15.0091 5.69461 15.0748 5.589C15.1405 5.48338 15.1816 5.36436 15.1951 5.24072C15.2086 5.11708 15.1942 4.99199 15.1529 4.87467C15.1116 4.75736 15.0445 4.65082 14.9565 4.56293L11.4365 1.04293C11.3486 0.956412 11.2426 0.890544 11.1261 0.850111C11.0096 0.809679 10.8856 0.795696 10.763 0.809178C10.6404 0.822661 10.5224 0.86327 10.4175 0.928057C10.3126 0.992844 10.2234 1.08018 10.1565 1.18373L7.79807 4.87973L3.08927 5.82053Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_539_13253">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </BaseSVG>
  )
}
